module.exports = __webpack_public_path__ + "6266f15e4a1b428d1f240e179a70d40f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/services/service_05.jpg
// module id = Autg
// module chunks = 0